import { Grid, Typography, makeStyles, Box } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import queryString from "query-string";

import GoogleSignIn from "./GoogleSignIn";
import AppleSignIn from "./AppleSignIn";
import { getCustomToken } from "../../../../services/accountApp/authService";
import { CustomTheme } from "../../../../types/customTheme";
import FacebookSignIn from "./FacebookSignIn";
import { AxiosError } from "axios";

const useStyles = makeStyles((theme: CustomTheme) => ({
  root: {
    height: "100vh",
    width: "100vw",
    display: "flex",
    flexDirection: "column",
  },
  bottomText: {
    textAlign: "center",
    fontSize: 12,
    marginTop: 28,
    padding: "0 20px",
  },
  header: {
    width: "200%",
    height: 600, // 🔼 Deep curve
    borderBottomLeftRadius: "100%",
    borderBottomRightRadius: "100%",
    position: "absolute",
    top: -380, // 🔼 Shift it upward to center the curve
    left: "-50%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "flex-end",
    paddingBottom: 24, // Optional space below logo
  },
  headerWrapper: {
    paddingTop: 220, // 🔼 Matches new curve depth
    position: "relative",
    width: "100%",
    overflow: "hidden",
  },
  content: {
    flexGrow: 1,
    padding: "20px 20px",
  },
  logo: {
    width: "112px",
    minHeight: "112px",
    marginBottom: 8,
    objectFit: "cover",
    marginTop: "140px",
    borderRadius: "50%",
  },
}));

interface ManageAppsProps {
  setAuthError: (msg: string) => void;
}

const LoginPage: React.FC<ManageAppsProps> = ({ setAuthError }) => {
  const classes = useStyles();
  const [privacyUrl, setPrivacyUrl] = useState<any>();
  const [params, setParams] = useState<any>({
    headColour: "#f57c00",
    backColour: "#ffffff",
    buttonColour: "#000000",
    headText: "#ffffff",
    backText: "#000000",
    ButtonText: "#ffffff",
    title: "Sign In",
    subTitle: "",
    logo: "",
    privacyUrl: "Privacy policy, Terms & Conditions and Data Use Policy.",
  });

  const handleCreateCustomToken = async (idToken: string) => {
    try {
      const res: any = await getCustomToken({ idToken: idToken });
      if (res?.status === 200) {
        // const customToken = res.data.customToken;
        // handlePostMessage(customToken);
        const redirectUri = queryString.parse(
          window.location.search,
        ).redirectUri;
        const queryParams = `t=${res.data.customToken}`;
        setTimeout(() => {
          window.location.href = `${redirectUri}?${queryParams}`;
        }, 500);
      } else {
        setAuthError("error2 ERROR_MESSAGE_UNEXPECTED_ERROR");
      }
    } catch (error) {
      const err: any = error as AxiosError;
      setAuthError(`error1 ${err.message}`);
    }
  };

  useEffect(() => {
    if (window.location.search) {
      const parsed = queryString.parse(window.location.search);
      const privacyUrl = queryString.parse(window.location.search).privacyUrl;
      setPrivacyUrl(privacyUrl || "");
      const hasQueryParams = Object.keys(parsed).length > 0;
      if (!hasQueryParams) return;

      // Fix color values: prepend '#' if not already
      const colorKeys = [
        "headColour",
        "backColour",
        "buttonColour",
        "headText",
        "backText",
        "ButtonText",
        "title",
        "subTitle",
        "logo",
      ];

      const updatedParams: any = { ...parsed };

      colorKeys.forEach((key) => {
        if (updatedParams[key] && typeof updatedParams[key] === "string") {
          const val = updatedParams[key] as string;
          updatedParams[key] =
            key === "title" || key === "subTitle" || key === "logo"
              ? val
              : `#${val}`;
        }
      });

      setParams((prev: any) => ({
        ...prev,
        ...updatedParams,
      }));
    }
  }, []);
  // Extract colors/texts with fallbacks
  // const {
  //   headColour = "#f57c00",
  //   backColour = "#ffffff",
  //   buttonColour = "#000000",
  //   headText = "#ffffff",
  //   backText = "#000000",
  //   ButtonText = "#ffffff",
  //   title = "Sign In",
  //   subTitle = "",
  //   logo = "",
  // } = params;

  const handleRedirectPrivacyUrl = () => {
    window.open(privacyUrl, "_blank");
  };

  return (
    <div
      className={classes.root}
      style={{ backgroundColor: params.backColour }}
    >
      <Box className={classes.headerWrapper}>
        <Box
          className={classes.header}
          style={{ backgroundColor: params.headColour }}
        >
          {params.logo ? (
            <>
              <img src={params.logo} alt="Logo" className={classes.logo} />
              <Typography variant="body1" style={{ color: params.headText }}>
                Sign In
              </Typography>
            </>
          ) : (
            <>
              <Typography
                variant="h5"
                style={{ color: params.headText, fontWeight: "bold" }}
              >
                {params.title}
              </Typography>
              {params.subTitle && (
                <Typography
                  variant="subtitle1"
                  style={{ color: params.headText }}
                >
                  {params.subTitle}
                </Typography>
              )}
            </>
          )}
        </Box>

        <Box className={classes.content}>
          <Grid container spacing={2} style={{ marginTop: "40px" }}>
            <Grid item xs={12}>
              <GoogleSignIn
                backText={params.backText}
                backColour={"#FFFFFF"}
                handleCreateCustomToken={handleCreateCustomToken}
              />
            </Grid>
            <Grid item xs={12} style={{ marginTop: "8px" }}>
              <AppleSignIn
                backText={params.backText}
                backColour={"#FFFFFF"}
                handleCreateCustomToken={handleCreateCustomToken}
              />
            </Grid>
            <Grid item xs={12} style={{ marginTop: "8px" }}>
              <FacebookSignIn
                backText={params.backText}
                backColour={"#FFFFFF"}
                handleCreateCustomToken={handleCreateCustomToken}
              />
            </Grid>
          </Grid>
          <Typography
            className={classes.bottomText}
            style={{ color: params.backText }}
          >
            By logging in to your account you're agreeing to our{" "}
            <span
              style={{
                fontWeight: "bold",
                textDecoration: "underline",
                cursor: "pointer",
              }}
              onClick={handleRedirectPrivacyUrl}
            >
              Privacy policy, Terms & Conditions and Data Use Policy.
            </span>
          </Typography>
        </Box>
      </Box>
    </div>
  );
};

export default LoginPage;
